var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order"},[_c('span',[_vm._v(_vm._s(_vm.order))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.total==0)),expression:"!(total==0)"}]},[_vm._v("/"+_vm._s(_vm.total))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3376dff1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/issue/order.vue
// module id = null
// module chunks = 